<template>
    <el-card class="box-card" v-loading="dataLoading">
        <div slot="header" class="clearfix">
            <span>
                <span class="el-icon-data-line"></span> 演出管理
            </span>
        </div>
        <div v-if="data" class="content">
            <el-row :gutter="20">
                <el-col :md="8" class="categoryDataList">
                    <router-link to="/activityManage/onlineVerify/list?auditStatus=1" class="category-item">
                        <div class="title">上线审核</div>
                        <div class="num clearfix">
                            <b>{{data.activityAuditTotalNum || 0}}</b> 当前待处理
                            <span class="el-icon-right fr"></span>
                        </div>
                    </router-link>
                    <router-link to="/activityManage/editVerify/list?status=1" class="category-item">
                        <div class="title">修改审核</div>
                        <div class="num clearfix">
                            <b>{{data.activityUpdateAuditTotalNum || 0}}</b> 当前待处理
                            <span class="el-icon-right fr"></span>
                        </div>
                    </router-link>
                    <router-link to="/finance/activity/settlement/list?isBalance=1" class="category-item">
                        <div class="title">结款</div>
                        <div class="num clearfix">
                            <b>{{data.receivablesTotalNum || 0}}</b> 当前待处理
                            <span class="el-icon-right fr"></span>
                        </div>
                    </router-link>
                    <router-link to="/activityManage/refundTicketAudit/list?status=1" class="category-item">
                        <div class="title">退票申请审核</div>
                        <div class="num clearfix">
                            <b>{{data.refundTicketAuditTotalNum || 0}}</b> 当前待处理
                            <span class="el-icon-right fr"></span>
                        </div>
                    </router-link>
                    <router-link to="/activityManage/activity/list" class="category-item">
                        <div class="title">演出上线</div>
                        <div class="num clearfix">
                            <b>{{data.totalNumSum || 0}}</b> 
                            <span class="el-icon-right fr"></span>
                        </div>
                    </router-link>
                </el-col>
                <el-col :md="16" >
                    <div id="activityDataChart" ref="activityDataChart"></div>
                </el-col>
            </el-row>
        </div>
    </el-card>
</template>

<script>
import { Chart } from '@antv/g2';

export default {
    props:{
        intervalData:{
            type: Object,
            default: () => null
        },
        daterange:{
            type: Array,
            default: () => []
        }
    },
    data(){
        return{
            dataLoading: false,
            data: null,
            chart: null,
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        intervalData(v1,v2){
            if(v1 && v1 != v2){
                this.getData();
            }
        }
    },
    methods:{
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/dashboard/activitydata",
                method: "POST",
                data: {
                    timeInterval: this.intervalData.timeInterval || "",
                    start: this.daterange.length > 0 ? this.daterange[0]: "",
                    end: this.daterange.length > 1 ? this.daterange[1]: "",
                }
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;

                        this.$nextTick(() => {
                            this.drawChart();
                        })
                        
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        
        drawChart(){
            if( this.chart ) this.chart.destroy();
            let _data = [];
            const _dataArry = [...this.data.totalNumChart.lineSeriesData];

            _dataArry.map( item => {
                _data.push({
                    name: item.name,
                    value: parseFloat(item.value)
                })
            })
            
            this.chart = new Chart({
                container: 'activityDataChart',
                autoFit: true,
                height: 400,
            });
            this.chart.data(_data);

            if( _dataArry.length > 7 ){
                this.chart.option('slider', {
                    start: (_dataArry.length - 7) / _dataArry.length,
                    end: 1,
                });
            }

            this.chart.tooltip({
                showTitle: false,
                showMarkers: false,
                showCrosshairs: true,
            });
            
            this.chart
                .line()
                .position('name*value')
                .shape('smooth')
                .tooltip('name*value', (name, value) => {
                    value = this.activeName == 1 ? parseFloat(value).toFixed(2) : value;
                    return {
                        name: name,
                        value: value,
                    };
                });

            this.chart.render();
        }
    }
}
</script>

<style lang="scss" scoped>
.categoryDataList{
    .category-item{
        border: 1px #eee solid;
        padding: 10px;
        display: block;
        border-radius: 4px;
        margin: 10px 0;
        .num{
            margin-top: 10px;
            color: $--color-info;
            b{
                font-weight: 700;
                font-size: 16px;
                color: $--color-theme;
            }
        }
    }
}

</style>